module.exports = __webpack_public_path__ + "static/media/tell.cc4c7d61.svg";